export const LOADING_TENANT = "LOADING_TENANT";
export const GET_TENANT_LIST = "GET_TENANT_LIST";
export const GET_TENANT_FIELDS = "GET_TENANT_FIELDS";
export const UPDATE_TENANT = "UPDATE_TENANT";
export const UPDATE_TENANT_DETAILS = "UPDATE_TENANT_DETAILS";
export const UPDATE_TENANT_FIELDS = "UPDATE_TENANT_FIELDS";
export const ADD_TENANT = "ADD_TENANT";
export const GET_TENANT_ID = "GET_TENANT_ID";
export const REMOVE_TENANT = "REMOVE_TENANT";
export const LOADING_LOGS = "LOADING_LOGS";
export const GET_USER_LOGS = "GET_USER_LOGS";
export const LOADING_MODULE = "LOADING_MODULE";
export const UPDATE_MODULE_CONFIG = "UPDATE_MODULE_CONFIG";
export const ADD_SIGNATURE = "ADD_SIGNATURE";
export const GET_SIGNATURE_BYID = "GET_SIGNATURE_BYID";
